<template>
  <DateSegments
    v-bind="{
      autofocus,
      dateHelpText,
      disabled,
      required,
      maxValue,
      minValue,
      identifier,
      errorText,
      errorTextDateRange,
      errorTextAge,
      todayDateCheckbox,
      todayDateCheckboxLabel
    }"
    v-model="date"
    :date-label="dateLabel || $t('preventionForm.birthDate.title')"
    @blur="$emit('blur')"
    @focus="$emit('focus', $event)"
    @todayClick="$emit('todayClick', $event)"
  />
</template>

<script>
import date from '@/mixins/date';
export default {
  name: 'DateSegmented',
  mixins: [date],
  props: {
    autofocus: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    dateHelpText: {
      type: String,
      default: ''
    },
    initialValue: {
      type: String,
      required: false
    },
    dateLabel: {
      type: String,
      default: null
    },
    maxValue: {
      type: String,
      default: null
    },
    minValue: {
      type: String,
      default: null
    },
    identifier: {
      type: String,
      required: false
    },
    errorText: {
      type: String,
      required: false
    },
    errorTextDateRange: {
      type: String,
      required: false
    },
    errorTextAge: {
      type: String,
      required: false
    },
    todayDateCheckbox: {
      type: Boolean,
      default: false
    },
    todayDateCheckboxLabel: {
      type: String,
      default: ''
    }
  },
  computed: {
    date: {
      get() {
        return this.$store.state.forms.date.date;
      },
      set(value) {
        this.$store.commit('forms/date/updateDate', value);
      }
    }
  },
  created() {
    if (this.initialValue) {
      const dateValue = new Date(this.initialValue);
      if (dateValue) {
        const yearToSend = dateValue.getFullYear();
        const monthToSend = this.padStartWithZeroes(dateValue.getMonth() + 1, 2);
        const dateToSend = this.padStartWithZeroes(dateValue.getDate(), 2);

        this.date =
          parseInt(yearToSend) > 0 || parseInt(monthToSend) > 0 || parseInt(dateToSend) > 0
            ? `${yearToSend}-${monthToSend}-${dateToSend}`
            : '';
      }
    }

    this.$eventHub.$on(
      `validateDateSegmented${this.identifier ? `_${this.identifier}` : ''}`,
      done => {
        this.$eventHub.$emit(
          `validateDateSegments${this.identifier ? `_${this.identifier}` : ''}`,
          result => {
            this.$store.commit('forms/date/setIsValid', result);
            done();
          }
        );
      }
    );
  },
  beforeDestroy() {
    this.$eventHub.$off(`validateDateSegmented${this.identifier ? `_${this.identifier}` : ''}`);
  }
};
</script>
